import { fromJS } from 'immutable';
import { createRelationalReportFromBaseReport } from 'reporting-snowflake/relational/utils/report-utils';
import ConditionalFormattingColorSelect from '../ConditionalFormattingColorSelect';
import { updateSnowflakeReportEncodingWithConditionalFormatting } from '../utils';
import { EVENTS } from '../../../lib/events';
import { useSnowflakeReportUpdater } from 'reporting-snowflake/relational/updaters/report/use-snowflake-updater';
import { jsx as _jsx } from "react/jsx-runtime";
const SnowflakeConditionalFormattingColorPalette = ({
  report,
  onChange,
  selectedColumnName,
  tracker
}) => {
  var _snowflakeReport$visu, _selectedColumnEncodi;
  const snowflakeReport = createRelationalReportFromBaseReport(report);
  const {
    columns
  } = snowflakeReport;
  const snowflakeUpdater = useSnowflakeReportUpdater(snowflakeReport);
  const encodings = (_snowflakeReport$visu = snowflakeReport.visual) === null || _snowflakeReport$visu === void 0 ? void 0 : _snowflakeReport$visu.encodings;
  const selectedColumn = selectedColumnName ? columns.get(selectedColumnName) : undefined;
  if (!selectedColumn) {
    return null;
  }
  const selectedColumnEncoding = encodings.get('columns').find(encodedColumn => encodedColumn.column === (selectedColumn === null || selectedColumn === void 0 ? void 0 : selectedColumn.get('alias')));
  const existingConditionalFormatting = selectedColumnEncoding === null || selectedColumnEncoding === void 0 || (_selectedColumnEncodi = selectedColumnEncoding.getIn(['options', 'format', 'conditionalFormatting'])) === null || _selectedColumnEncodi === void 0 ? void 0 : _selectedColumnEncodi.toJS();
  const selectedPalette = existingConditionalFormatting === null || existingConditionalFormatting === void 0 ? void 0 : existingConditionalFormatting.palette;
  const updateColorPalette = palette => {
    tracker === null || tracker === void 0 || tracker.track(EVENTS.conditionalFormattingInteraction, {
      actionType: 'updateColorPalette',
      color: palette
    });
    const toIndex = encodings.get('columns').indexOf(selectedColumnEncoding);
    const updatedConditionalFormatting = Object.assign({}, existingConditionalFormatting, {
      palette
    });
    const updatedEncoding = selectedColumnEncoding.setIn(['options', 'format', 'conditionalFormatting'], fromJS(updatedConditionalFormatting));
    return updateSnowflakeReportEncodingWithConditionalFormatting({
      updatedEncoding,
      toIndex,
      snowflakeUpdater
    });
  };
  const handleChange = palette => {
    const nextReport = updateColorPalette(palette);
    onChange(nextReport);
  };
  return /*#__PURE__*/_jsx(ConditionalFormattingColorSelect, {
    onChange: handleChange,
    selectedPalette: selectedPalette
  });
};
export default SnowflakeConditionalFormattingColorPalette;